<template>
  <edit-modal
    :caption="caption"
    :isActive="isActive">
    <div class="field">
      <label class="label">Naam</label>
      <div class="control">
        <textarea
          name="name"
          v-model="name"
          class="textarea"
        ></textarea>
      </div>
    </div>

    <div class="field">
      <label class="label">Kwalificatiedossier</label>
      <div class="control">
        <select-wrapper
          :value="dossierNr"
          :options="myDossierOptions"
          @update="setDossierNr"
          @remove="unsetDossierNr"
          placeholder="Selecteer een kwalificatiedossier"
        ></select-wrapper>
      </div>
    </div>

    <div
      class="field"
      v-if="dossierNr"
    >
      <label class="label">Profiel</label>
      <div class="control">
        <select-wrapper
          :value="profileNr"
          :options="myProfileOptions"
          placeholder="Selecteer een profiel"
          @update="setProfileNr"
          @remove="resetProfileNr"
        ></select-wrapper>
      </div>
    </div>

    <div
      v-if="bundle"
      class="field"
    >
      <label class="label">Zichtbaarheid</label>

      <ul>
        <li
          class="box"
          v-for="table in tables"
          :key="table.id"
        >

          <span class="icon">
            <i
              class="fas"
              aria-hidden="true"
              :class="isHidden('tables', table.id) ? 'fa-eye-slash' : 'fa-eye'"
              @click="toggleVisibility('tables', table.id)"
            ></i>
          </span>

          <span
            class="icon is-pulled-right"
            @click="toggle(table.id)"
          >
            <i
              class="fas"
              aria-hidden="true"
              :class="isExpanded(table.id) ? 'fa-caret-down' : 'fa-caret-left'"
            ></i>
          </span>

          {{ table.name }}

          <div v-show="isExpanded(table.id)">
            <hr>
            <div class="field has-addons">
              <p class="control">
                <button
                  class="button"
                  :class="{ 'is-info': activeChild === 0 }"
                  @click="activeChild = 0"
                >
                  <span>Rapporten</span>
                </button>
              </p>

              <p class="control">
                <button
                  class="button"
                  :class="{ 'is-info': activeChild === 1 }"
                  @click="activeChild = 1"
                >
                  <span>Content</span>
                </button>
              </p>
            </div>

            <ul>
              <li
                v-for="item in table[children[activeChild]]"
                :key="item.id">

                <span v-if="!isHidden('tables', table.id)" class="icon">
                  <i
                    class="fas"
                    aria-hidden="true"
                    :class="isHidden(children[activeChild], item.id) ? 'fa-eye-slash' : 'fa-eye'"
                    @click="toggleVisibility(children[activeChild], item.id)"
                  ></i>
                </span>

                <span v-else class="icon">
                  <i class="fas fa-eye-slash"></i>
                </span>

                {{ item.name }}
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>

    <save-buttons
      :disabled="formErrors"
      @save="save"
      @cancel="close"
    ></save-buttons>
  </edit-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'
import SelectWrapper from '@/components/wrappers/SelectWrapper'

export default {
  props: [
    'isActive'
  ],

  components: {
    EditModal,
    SaveButtons,
    SelectWrapper
  },

  computed: {
    ...mapGetters({
      bundle: 'bundles/bundle',
      tables: 'tables/tables',
      dossiers: 'dossiers/dossiers'
    }),

    formErrors () {
      if (!this.name) return true

      return !!(this.dossierNr && !this.profileNr);
    },

    myDossierOptions () {
      return this.dossiers.map((dossier) => {
        return {
          label: `${dossier.nr} ${dossier.titel}`,
          value: parseInt(dossier.nr)
        }
      })
    },

    myProfileOptions () {
      return this.dossiers.find(dossier => parseInt(dossier.nr) === this.dossierNr).profielen.map((profile) => {
        return {
          label: `${profile.nr} ${profile.titel}`,
          value: parseInt(profile.nr)
        }
      })
    },

    caption () {
      return (this.bundle) ? `Bundel ${this.bundle.name} bewerken` : 'Nieuwe bundel'
    }
  },

  data () {
    return {
      name: null,
      dossierNr: null,
      profileNr: null,
      profiles: [],
      hasDisabled: [],
      expanded: null,
      activeChild: 0,
      children: [
          'reports',
          'pages'
      ]
    }
  },

  watch: {
    bundle () {
      this.$store.commit('dossiers/PURGE_DOSSIER')

      if (this.bundle) {
        this.name = this.bundle.name
        this.dossierNr = this.bundle.dossier_nr
        this.profileNr = this.bundle.profile_nr
        this.hasDisabled = JSON.parse(JSON.stringify(this.bundle.has_disabled))
      }
    },

    isActive () {
      this.name = this.dossierNr = this.profileNr = null
    },

    dossierNr () {
      if (this.dossierNr) {
        this.$store.dispatch('dossiers/find', {
          'nr': this.dossierNr
        })
      }
    }
  },

  methods: {
    save () {
      this.$emit('save', {
        name: this.name,
        dossierNr: this.dossierNr,
        profileNr: this.profileNr,
        hasDisabled: this.hasDisabled
      })
    },

    close () {
      this.dossierNr = this.profileNr = null
      this.$emit('close')
    },

    setDossierNr (payload) {
      this.dossierNr = payload.value
      this.resetProfileNr()
    },

    unsetDossierNr () {
      this.dossierNr = null
      this.resetProfileNr()
    },

    setProfileNr (payload) {
      this.profileNr = payload.value
    },

    resetProfileNr () {
      this.profileNr = null
    },

    setVisibilityTab (idx) {
      this.visibilityActiveTab = idx
    },

    toggle (id) {
      this.expanded = (this.expanded == id) ? null : id
    },

    toggleVisibility (model, id) {
      if (this.isHidden(model, id)) {
        const idx = this.hasDisabled[model].findIndex(item => item === id)
        if (idx !== -1) this.hasDisabled[model].splice(idx, 1)
      } else {
        this.hasDisabled[model].push(id)
      }
    },

    isExpanded (id) {
      return this.expanded === id
    },

    isHidden (model, id) {
      if (this.hasDisabled[model]) {
        return this.hasDisabled[model].includes(id)
      }

      return false
    }
  }
}
</script>

<style scoped>
.tabs a {
  text-decoration: none;
}

.button.is-text {
  text-decoration: none;
}
</style>
